export default "/assets/2c1f893c6780e4fc.svg"